import ErrorContext from "@src/components/apollo/errorprovider/ErrorContext";
import { useContext } from "react";

export default function useErrorDialog() {
    return useContext(ErrorContext);
}
